import { browser } from '$app/env';
import {
	apiAppAuthGoogleauthGenerateauthurl,
	type GoogleAuth,
	type GoogleCalendar
} from '#lib/types/generated/index.js';
import { writable } from 'svelte/store';

export const googleCalendarStore = writable<GoogleCalendar[]>([]);
export const googleAuthStore = writable<GoogleAuth[]>([]);

export const GOOGLE_AUTH_REDIRECT_KEY = 'google_auth_redirect_path';

export function startGoogleAuth() {
	if (!browser) return;

	const url = new URL(window.location.href);
	if (url.searchParams.has('google_error')) {
		url.searchParams.delete('google_error');
	}
	const currentPath = url.pathname + url.search;
	localStorage.setItem(GOOGLE_AUTH_REDIRECT_KEY, currentPath);

	apiAppAuthGoogleauthGenerateauthurl().then((result) => {
		window.location.href = result.auth_url;
	});
}
